var application = {
    debug: 0
};

var appGlobal = {};